import { Box as Flex } from '@material-ui/core';

import { isTextSelection } from '@tiptap/react';
import { BubbleMenu } from '@tiptap/react/menus';

import { useCurrentEditor } from './Context';
import { ToolbarCard } from './FloatingCard';
import { InlineFormatButtons } from './InlineFormatButtons';

export const SimpleSelectionToolbar = () => {
  const { editor } = useCurrentEditor();

  return (
    <BubbleMenu
      editor={editor ?? undefined}
      options={{ offset: 6, placement: 'top' }}
      style={{ zIndex: 99999, position: 'relative', borderRadius: 10 }}
      appendTo={() => document.body}
      shouldShow={({ view, state, from, to }) => {
        if (!view.hasFocus()) return false;
        const { doc, selection } = state;
        const isText = isTextSelection(selection);
        if (!isText) return false;
        const isEmpty =
          selection.empty || (isText && doc.textBetween(from, to).length === 0);
        if (isEmpty) return false;
        return true;
      }}
    >
      <ToolbarCard>
        <Flex
          display="flex"
          style={{
            gap: 'var(--encore-spacing-tighter-5)',
          }}
        >
          <InlineFormatButtons />
        </Flex>
      </ToolbarCard>
    </BubbleMenu>
  );
};
